var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentPage === 'home' || _vm.currentPage === 'main')?_c('Main',{on:{"orderNow":_vm.orderNow}}):(_vm.currentPage === 'orderNow')?_c('OrderNow',{on:{"main":_vm.main}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }